export default "__VITE_ASSET__DJzWutxP__"